/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoRoutePlanDeleteManyMutation($routePlanIds: [ID!] !) {
    PhoneNumberoRoutePlanDeleteMany(routePlanIds: $routePlanIds){
      message
      status
    }
  }
`
